class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    const scripts = this.querySelectorAll(':scope > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      if (!window.wetheme?.webcomponentRegistry) {
        console.error('SafeLoadScripts: window.wetheme.webcomponentRegistry is not defined');
        return;
      }

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;

        if (this.parentElement) {
          this.parentElement.appendChild(postLoadedScript);
        }
      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);